<template>
  <div class="audience-form">
    <Logo />
    <form @submit.prevent="login()">
      <h3 class="text-center">
        {{ $t('Enter your authentication code') }}
      </h3>
      <div class="item-input">
        <input
          type="number"
          maxlength="50"
          v-model="authenticationCode"
          class="text-center item-input-text"
        >
      </div>
      <div>
        <ui-button
          block
          size="lg"
          type="submit"
          :disabled="submiting || !authenticationCode"
          :class="{'button-disabled': submiting || !authenticationCode}"
        >
          <span>
            {{ $t('Let me in') }}
          </span>
          <i class="fas fa-check" v-if="!submiting" />
          <ui-spinner v-if="submiting" />
        </ui-button>
      </div>
      <div class="text-center text-danger padding" v-if="textError">
        {{ textError }}
      </div>
    </form>
  </div>
</template>

<script>

// UI
import { mapState } from 'vuex'
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'

import config from '@/config'
import storage from '@/services/storage'
import socket from '@/socket'
import EventBus from '@/eventBus'

import Logo from '@/components/Logo'

export default {
  components: {
    UiButton,
    UiSpinner,
    Logo,
  },
  data() {
    return {
      textError: '',
      submiting: false,
      authenticationCode: '',
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
    this.$store.state.disableScrollBody = true
    EventBus.$on('audience-authen-connected', () => {
      if (this.authenticationCode) {
        setTimeout(() => {
          this.$store.state.authenticationCode = this.authenticationCode
          this.submiting = false
        }, 1000)
      }
    })
    document.body.classList.add('hide-qa-button')
    document.body.classList.add('open-form-authen')
  },
  destroyed() {
    this.$store.state.disableScrollBody = false
    document.body.classList.remove('hide-qa-button')
    document.body.classList.remove('open-form-authen')
  },
  methods: {
    async login() {
      const payload = {
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        authenticationCode: this.authenticationCode,
        audienceId: this.audienceId,
      }
      if (!this.authenticationCode) {
        this.textError = 'Invalid authentication code'
      }
      if (this.submiting) return
      this.submiting = true
      try {
        await this.$http.post(config.api.audienceCheckAuthentication, payload)
        document.body.classList.add('hide-popup-connect-lost')
        socket.updateQuery({
          authCode: `${this.presentation.uniqueAccessCode}-${this.authenticationCode}`,
        })
        storage.setValueByPresentation(
          this.presentation.id,
          'authenticationCode',
          this.authenticationCode,
        )
      } catch (error) {
        this.textError = error.body.message
        this.submiting = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audience-form {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 1000;
  padding: 16px;
  color: #333;

  form {
    max-width: 678px;
    margin: 0 auto;
  }

  .item-input {
    position: relative;
    margin-bottom: 16px;
    .invalid-team-note {
      padding-top: 7px;
    }
    .item-input-icon {
      cursor: pointer;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type=number] {
      -moz-appearance: textfield;
    }
  }
  .button-submit {
    .loading-spinner {
      margin-bottom: 0px;
    }
  }
  .button-disabled {
    opacity: 0.7;
  }
}
.input-label {
  text-align: left;
}
</style>
